<template>
  <b-container fluid>
    <div class="d2-mt">
      <el-form ref="formData" :model="formData" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_category') || '素材分类'"
              prop="deCategoryCode"
            >
              <dict-select
                v-model="formData.deCategoryCode"
                :disabled="disabled"
                filterable
                clearable
                url="/digitalCenter/common/dict/elementCategorySelect"
                size="medium"
                :placeholder="$l('form_label_category') || '素材分类'"
                style="width: 100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_name_cn') || '中文名称'"
              prop="deName"
            >
              <el-input
                v-model="formData.deName"
                :placeholder="$l('form_label_name_cn') || '中文名称'"
                maxlength="50"
                disabled
                clearable
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_name_en') || '英文名称'"
              prop="deNameEn"
            >
              <el-input
                v-model="formData.deNameEn"
                :placeholder="$l('form_label_name_en') || '英文名称'"
                maxlength="50"
                disabled
                clearable
                size="medium"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_describe') || '素材描述'"
              prop="deMemo"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 6 }"
                v-model="formData.deMemo"
                maxlength="200"
                clearable
                size="medium"
                :placeholder="$l('form_label_describe') || '素材描述'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <Attribute
              size="medium"
              :span="8"
              ref="attribute"
              :params="attrParams"
            />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-upload
              ref="upload"
              multiple
              drag
              action="/oss/ossUploadReturnUrlAndFileId"
              :auto-upload="false"
              style="width: 100%"
              :on-change="onFileChange"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持上传jpg/png/jpeg/gif文件
              </div>
            </el-upload>
          </el-col>
        </el-row>
      </el-form>
      <!--按钮-->
      <div class="d2-mt">
        <el-row type="flex" justify="end">
          <el-col :span="12"></el-col>
          <el-col :span="12">
            <div style="float: right;">
              <el-button @click="close" size="small">{{
                $l('form_button_return') || '返回'
              }}</el-button>
              <el-button @click="saveData" size="small" type="primary">{{
                $l('form_button_save') || '保存'
              }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </b-container>
</template>
<script>
import Attribute from '@/views/digital/components/attribute'
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  components: {
    Attribute,
  },
  props: {},
  data() {
    return {
      imageTypeList: ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'],
      disabled: false,
      fileData: {
        // 文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles',
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: localStorage.getItem('token'),
      },
      formData: {
        deCode: '',
        deName: '',
        deNameEn: '',
        deStatus: 'Y',
        custCode: '',
        deCategoryCode: '',
        deImageCode: '',
        deImageUrl: '',
        deThumbImageCode: '',
        deThumbImageUrl: '',
        deMemo: '',
      },
      rules: {
        deCategoryCode: [
          {
            required: true,
            message: this.$l('form_rule_category') || '请选择素材分类',
            trigger: 'change',
          },
        ],
      },
      choceImageList: [],
    }
  },
  created() {
    this.init()
  },
  activated() {},
  watch: {},
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.deCode,
        templateCategoryCode: this.formData.deCategoryCode,
        templateType: 'D',
      }
    },
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    onFileChange(file, fileList) {
      if (file.status === 'ready') {
        let index = this.imageTypeList.indexOf(file.raw.type)
        if (index < 0) {
          this.$message.warning('不支持上传' + file.raw.type + '类型！')
          return false
        }
        //原图上传
        this.push({
          file: file.raw,
          added: ({ md5, suffix }) => {
            let code = md5 + '.' + suffix
            this.choceImageList.push({
              deImageCode: code,
              deThumbImageCode: code,
            })
          },
        })
      }
    },
    init() {
      this.resetData()
      this.addLoad('')
    },
    addLoad() {
      if (this.$refs.from) {
        this.$refs.from.resetFields()
      }
      // this.$refs.attribute.load(this.attrParams)
    },
    saveData() {
      const form = this.$refs.formData
      const attrForm = this.$refs.attribute.$refs.form

      if (this.choceImageList.length < 1) {
        this.$message.warning('请选择需要上传的图片')
        return false
      }

      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.formData.attrData = this.$refs.attribute.getFormData()
          //验证素材描述和属性是否都为空
          let result = this.validDeMemoAndElements(this.formData)
          if (!result) {
            return
          }
          let tempList = []
          this.choceImageList.forEach((item) => {
            let tempData = { ...this.formData }
            tempData.deImageCode = item.deImageCode
            tempData.deThumbImageCode = item.deThumbImageCode
            tempList.push(tempData)
          })

          this.$api
            .batchAddDesignElementsInfoApi({
              formDataList: tempList,
            })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('tips_save_ok') || '保存成功',
                type: 'success',
              })
              if (this.$refs.upload) {
                this.$refs.upload.clearFiles()
              }
              this.init()
              this.$emit('saveOk')
            })
        }
      })
    },
    //验证素材描述和属性是否都为空
    validDeMemoAndElements(formData) {
      if (formData.deMemo) {
        return true
      } else {
        //判断属性是否都为空
        let attributeList = formData.attrData.attributeList
        let result = false
        if (attributeList) {
          attributeList.forEach((item) => {
            if (item.attributeValueZh) {
              result = true
            }
          })
        }
        if (result) {
          return true
        } else {
          this.$message.warning(
            this.$l('tips_materialDescription') ||
              '素材描述和Attribute不能都为空！'
          )
          return false
        }
      }
    },
    // 重置表单数据
    resetData() {
      this.formData = {
        deCode: '',
        deName: '',
        deNameEn: '',
        tagList: [],
        deStatus: 'Y',
        custCode: '',
        deCategoryCode: '',
        deImageCode: '',
        deImageUrl: '',
        deThumbImageCode: '',
        deThumbImageUrl: '',
        deMemo: '',
      }
      this.choceImageList = []
    },
    close() {
      this.init()
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}

.text-annotation {
  color: $color-primary;
  font-size: 13px;
}

.avatar-uploader {
  i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #409eff;
    }
  }
}

.icon-right {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}

.events-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px !important;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}

.events-uploader-icon-small {
  font-size: 28px;
  color: #8c939d;
  width: 120px !important;
  height: 80px;
  line-height: 80px !important;
  text-align: center;
}

.events {
  width: 300px !important;
  height: 200px;
  display: block;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
